'use strict';

var _regeneratorRuntime = require("C:\\Users\\chris\\Documents\\Code\\PerspectiveDeveloper\\CattlepassDapp\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _wrapAsyncGenerator = require("C:\\Users\\chris\\Documents\\Code\\PerspectiveDeveloper\\CattlepassDapp\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/wrapAsyncGenerator");

var _awaitAsyncGenerator = require("C:\\Users\\chris\\Documents\\Code\\PerspectiveDeveloper\\CattlepassDapp\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/awaitAsyncGenerator");

var _asyncIterator = require("C:\\Users\\chris\\Documents\\Code\\PerspectiveDeveloper\\CattlepassDapp\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/asyncIterator");

var _asyncGeneratorDelegate = require("C:\\Users\\chris\\Documents\\Code\\PerspectiveDeveloper\\CattlepassDapp\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/asyncGeneratorDelegate");

var HTTP = require('../http');
/**
 *
 * @param {string} url
 * @param {import("../types").HTTPOptions} [options]
 * @returns {{ path: string; content?: AsyncIterable<Uint8Array> }}
 */


var urlSource = function urlSource(url, options) {
  return {
    path: decodeURIComponent(new URL(url).pathname.split('/').pop() || ''),
    content: readURLContent(url, options)
  };
};
/**
 *
 * @param {string} url
 * @param {import("../types").HTTPOptions} [options]
 * @returns {AsyncIterable<Uint8Array>}
 */


function readURLContent(_x, _x2) {
  return _readURLContent.apply(this, arguments);
}

function _readURLContent() {
  _readURLContent = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url, options) {
    var http, response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            http = new HTTP();
            _context.next = 3;
            return _awaitAsyncGenerator(http.get(url, options));

          case 3:
            response = _context.sent;
            return _context.delegateYield(_asyncGeneratorDelegate(_asyncIterator(response.iterator()), _awaitAsyncGenerator), "t0", 5);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _readURLContent.apply(this, arguments);
}

module.exports = urlSource;